import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ClickOutside from '@/mls-filter/directives/click-outside.js';

const app = createApp(App)
    .use(router)
    .use(store)
    .directive('click-outside', ClickOutside)
    .mount('#app');

// (window as any).alertExists = store.getters.alertExists;
// (window as any).currentHash = store.getters.currentHash;
(window as any).store = store;